import { WarrantyLogModel } from './types';
import { crateQueryResponseContextFor } from 'components/table/contexts/query-response';

const warrantyLogContext = crateQueryResponseContextFor<WarrantyLogModel>();

export { warrantyLogContext };
